module.exports = __webpack_public_path__ + "static/media/yesterdayLogo.ba07f693.png";